import { Entry } from 'contentful'
import { ISpacer } from 'app/_components/ContentfulPage/ConfigurableSpacer/Spacer'
import { IContentfulSpacer } from 'types/contentful/spacer'

export const parseSpacer = (
  contentfulSpacer: Entry<IContentfulSpacer>
): ISpacer => {
  const spacer = {
    id: contentfulSpacer?.sys?.id,
    componentKey: 'spacer',
    backgroundColor: contentfulSpacer?.fields?.backgroundColor,
    size: contentfulSpacer?.fields?.size,
  }
  return spacer
}
